import {
  MoneyNotFound02Icon,
  PaymentSuccess01Icon
} from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { VerificationNames } from "shared/types";
import { ReportHeader } from "views/applications-id-report/components/ReportHeader";
import { useCombinedIncomeContext } from "../providers/useCombinedIncome";

const DISABLED_ACTION_TOOLTIP =
  "Available once the applicant starts filling in the income verification";

export const RequestIncomeVerificationSlice = () => {
  const {
    applicationId,
    applicantId,
    applicationStatus,
    isRequestingNewIncome,
    reportModals: { setShowRequestNewIncomeModal }
  } = useCombinedIncomeContext();

  return (
    <>
      <ReportHeader
        applicationStatus={applicationStatus}
        applicationId={applicationId || "0"}
        title="Income history"
        applicantId={applicantId || 0}
        name={VerificationNames.CombinedIncome}
        onRerunReport={() => setShowRequestNewIncomeModal(true)}
        reRunReportButtonText="Request verification"
        reRunReportButtonHugeIcon={PaymentSuccess01Icon}
        reRunReportButtonHugeIconStrokeWidth={1.5}
        reRunLoading={isRequestingNewIncome}
        printDisabled
        printDisabledTooltip={DISABLED_ACTION_TOOLTIP}
        printTooltipPlacement="bottom"
      />

      <div className="flex flex-col items-center justify-center text-center min-h-[400px] gap-3">
        <div className="flex justify-center items-center h-[100px] w-[100px] rounded-full bg-alpha-20 shrink-0">
          <HugeiconsIcon
            icon={MoneyNotFound02Icon}
            size={46}
            className="text-content-1000"
            strokeWidth={1}
          />
        </div>
        <p className="text-base font-bold text-content-500">No income report</p>
        <p className="text-sm font-medium text-content-300">
          You can request income verification once the applicant submits their
          application
        </p>
      </div>
    </>
  );
};
